export function paging(rows: any[], page: number, rowsPerPage: number) {
  const start = (page - 1) * rowsPerPage
  const end = page * rowsPerPage
  return rows.slice(start, end)
}
